// Base URL for the backend API. Set REACT_APP_API_URL at build time to point
// at a deployed backend; falls back to the local dev server otherwise.
export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4567";
